import { FC } from 'react';
import useDrawer from '@/hooks/use-drawer.hook';
import ConversationHeader from '.';
import FlatButton from '@/components/flat-button';

interface Props {
  resourceId: string;
  openConversationId: string;
  focusedRequestId?: string;
  anchorActivityId?: string;
}

const PartialConversationHeader: FC<Props> = ({
  resourceId,
  openConversationId,
  focusedRequestId,
  anchorActivityId,
}) => {
  const { openDrawer } = useDrawer();

  const handleViewEntireConversation = () => {
    openDrawer('conversation', {
      conversationId: openConversationId,
      ...(focusedRequestId && { requestId: focusedRequestId }),
      ...(anchorActivityId && { anchorActivityId }),
    });
  };

  const leftElement = (
    <FlatButton
      label="View Entire Conversation"
      color="link"
      onClick={handleViewEntireConversation}
      size="small"
    />
  );

  return <ConversationHeader resourceId={resourceId} leftElement={leftElement} />;
};

export default PartialConversationHeader;
